import { Card, Text } from '@nimbus-ds/components';
import { Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import RulesList from './RulesList';

function RulesListBodyAndFooterSkeleton() {
  const { Body } = Card;
  const t = useTranslationShipping('deliveryMethods.addressingConfigurationV2');

  return (
    <Body>
      <Stack column spacing="base" align="stretch">
        <Text fontSize="base" lineHeight="base" textAlign="left">
          {t('info.description')}
        </Text>
        <RulesList.Skeleton />
      </Stack>
    </Body>
  );
}

export default RulesListBodyAndFooterSkeleton;
